@file:OptIn(InternalResourceApi::class)

package crossly.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/crossly.shared.generated.resources/"

@delegate:ResourceContentHash(-2_028_467_185)
internal val Res.string.settings_section_play: StringResource by lazy {
      StringResource("string:settings_section_play", "settings_section_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17301, 45),
      ))
    }

@delegate:ResourceContentHash(2_677_240)
internal val Res.string.settings_section_you: StringResource by lazy {
      StringResource("string:settings_section_you", "settings_section_you", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17347, 32),
      ))
    }

@delegate:ResourceContentHash(1_989_448_328)
internal val Res.string.settings_share_app: StringResource by lazy {
      StringResource("string:settings_share_app", "settings_share_app", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17475, 46),
      ))
    }

@delegate:ResourceContentHash(918_170_545)
internal val Res.string.settings_share_app_summary: StringResource by lazy {
      StringResource("string:settings_share_app_summary", "settings_share_app_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17380, 94),
      ))
    }

@delegate:ResourceContentHash(1_369_671_482)
internal val Res.string.settings_starters: StringResource by lazy {
      StringResource("string:settings_starters", "settings_starters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17808, 45),
      ))
    }

@delegate:ResourceContentHash(2_075_034_501)
internal val Res.string.settings_starters_few: StringResource by lazy {
      StringResource("string:settings_starters_few", "settings_starters_few", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17522, 37),
      ))
    }

@delegate:ResourceContentHash(2_016_957_626)
internal val Res.string.settings_starters_many: StringResource by lazy {
      StringResource("string:settings_starters_many", "settings_starters_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17560, 38),
      ))
    }

@delegate:ResourceContentHash(63_508_044)
internal val Res.string.settings_starters_none: StringResource by lazy {
      StringResource("string:settings_starters_none", "settings_starters_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17599, 38),
      ))
    }

@delegate:ResourceContentHash(-933_420_676)
internal val Res.string.settings_starters_summary: StringResource by lazy {
      StringResource("string:settings_starters_summary", "settings_starters_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17638, 169),
      ))
    }

@delegate:ResourceContentHash(54_228_438)
internal val Res.string.settings_theme_mode: StringResource by lazy {
      StringResource("string:settings_theme_mode", "settings_theme_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17980, 43),
      ))
    }

@delegate:ResourceContentHash(1_883_571_262)
internal val Res.string.settings_theme_mode_dark: StringResource by lazy {
      StringResource("string:settings_theme_mode_dark", "settings_theme_mode_dark", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17854, 40),
      ))
    }

@delegate:ResourceContentHash(-2_143_038_200)
internal val Res.string.settings_theme_mode_light: StringResource by lazy {
      StringResource("string:settings_theme_mode_light", "settings_theme_mode_light", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17895, 41),
      ))
    }

@delegate:ResourceContentHash(-959_261_427)
internal val Res.string.settings_theme_mode_system: StringResource by lazy {
      StringResource("string:settings_theme_mode_system", "settings_theme_mode_system", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17937, 42),
      ))
    }

@delegate:ResourceContentHash(1_051_875_662)
internal val Res.string.settings_theme_palette: StringResource by lazy {
      StringResource("string:settings_theme_palette", "settings_theme_palette", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18024, 46),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18071, 34),
      ))
    }

@delegate:ResourceContentHash(362_774_645)
internal val Res.string.settings_varies_by_level: StringResource by lazy {
      StringResource("string:settings_varies_by_level", "settings_varies_by_level", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18106, 108),
      ))
    }

@delegate:ResourceContentHash(-1_645_616_660)
internal val Res.string.share_badge_text: StringResource by lazy {
      StringResource("string:share_badge_text", "share_badge_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18215, 84),
      ))
    }

@delegate:ResourceContentHash(-794_931_158)
internal val Res.string.share_streak_text: StringResource by lazy {
      StringResource("string:share_streak_text", "share_streak_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18300, 141),
      ))
    }

@delegate:ResourceContentHash(-1_132_238_887)
internal val Res.string.streak_at_risk: StringResource by lazy {
      StringResource("string:streak_at_risk", "streak_at_risk", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18442, 74),
      ))
    }

@delegate:ResourceContentHash(-272_745_177)
internal val Res.string.streak_best: StringResource by lazy {
      StringResource("string:streak_best", "streak_best", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18517, 39),
      ))
    }

@delegate:ResourceContentHash(54_142_967)
internal val Res.string.streak_broken: StringResource by lazy {
      StringResource("string:streak_broken", "streak_broken", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18557, 57),
      ))
    }

@delegate:ResourceContentHash(2_543_797)
internal val Res.string.streak_day_fri: StringResource by lazy {
      StringResource("string:streak_day_fri", "streak_day_fri", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18615, 26),
      ))
    }

@delegate:ResourceContentHash(2_582_237)
internal val Res.string.streak_day_mon: StringResource by lazy {
      StringResource("string:streak_day_mon", "streak_day_mon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18642, 26),
      ))
    }

@delegate:ResourceContentHash(2_648_546)
internal val Res.string.streak_day_sat: StringResource by lazy {
      StringResource("string:streak_day_sat", "streak_day_sat", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18669, 26),
      ))
    }

@delegate:ResourceContentHash(2_648_546)
internal val Res.string.streak_day_sun: StringResource by lazy {
      StringResource("string:streak_day_sun", "streak_day_sun", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18696, 26),
      ))
    }

@delegate:ResourceContentHash(2_626_443)
internal val Res.string.streak_day_thu: StringResource by lazy {
      StringResource("string:streak_day_thu", "streak_day_thu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18723, 26),
      ))
    }

@delegate:ResourceContentHash(2_626_443)
internal val Res.string.streak_day_tue: StringResource by lazy {
      StringResource("string:streak_day_tue", "streak_day_tue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18750, 26),
      ))
    }

@delegate:ResourceContentHash(2_678_337)
internal val Res.string.streak_day_wed: StringResource by lazy {
      StringResource("string:streak_day_wed", "streak_day_wed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18777, 26),
      ))
    }

@delegate:ResourceContentHash(548_473_405)
internal val Res.string.streak_frozen_hint: StringResource by lazy {
      StringResource("string:streak_frozen_hint", "streak_frozen_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18804, 74),
      ))
    }

@delegate:ResourceContentHash(-1_792_781_901)
internal val Res.string.streak_played_today: StringResource by lazy {
      StringResource("string:streak_played_today", "streak_played_today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18879, 71),
      ))
    }

@delegate:ResourceContentHash(-1_700_702_690)
internal val Res.string.streak_restore_cta: StringResource by lazy {
      StringResource("string:streak_restore_cta", "streak_restore_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18951, 46),
      ))
    }

@delegate:ResourceContentHash(-1_977_898_449)
internal val Res.string.streak_share: StringResource by lazy {
      StringResource("string:streak_share", "streak_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18998, 28),
      ))
    }

@delegate:ResourceContentHash(-632_859_617)
internal val Res.string.streak_start: StringResource by lazy {
      StringResource("string:streak_start", "streak_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19027, 68),
      ))
    }

@delegate:ResourceContentHash(-952_391_666)
internal val Res.string.streak_title: StringResource by lazy {
      StringResource("string:streak_title", "streak_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19142, 40),
      ))
    }

@delegate:ResourceContentHash(1_921_788_501)
internal val Res.string.streak_title_zero: StringResource by lazy {
      StringResource("string:streak_title_zero", "streak_title_zero", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19096, 45),
      ))
    }

@delegate:ResourceContentHash(-1_095_232_859)
internal val Res.string.tier_easy: StringResource by lazy {
      StringResource("string:tier_easy", "tier_easy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19183, 25),
      ))
    }

@delegate:ResourceContentHash(762_570_809)
internal val Res.string.tier_expert: StringResource by lazy {
      StringResource("string:tier_expert", "tier_expert", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19209, 27),
      ))
    }

@delegate:ResourceContentHash(-668_846_130)
internal val Res.string.tier_hard: StringResource by lazy {
      StringResource("string:tier_hard", "tier_hard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19237, 25),
      ))
    }

@delegate:ResourceContentHash(-1_460_477_491)
internal val Res.string.tier_medium: StringResource by lazy {
      StringResource("string:tier_medium", "tier_medium", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19263, 27),
      ))
    }

@delegate:ResourceContentHash(919_452_822)
internal val Res.string.web_share_challenge_from: StringResource by lazy {
      StringResource("string:web_share_challenge_from", "web_share_challenge_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19291, 76),
      ))
    }

@delegate:ResourceContentHash(-1_505_125_104)
internal val Res.string.web_share_invite_from: StringResource by lazy {
      StringResource("string:web_share_invite_from", "web_share_invite_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19368, 73),
      ))
    }

@delegate:ResourceContentHash(668_568_056)
internal val Res.string.web_share_ios_hint: StringResource by lazy {
      StringResource("string:web_share_ios_hint", "web_share_ios_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19442, 126),
      ))
    }

@delegate:ResourceContentHash(-46_023_246)
internal val Res.string.web_share_play_store: StringResource by lazy {
      StringResource("string:web_share_play_store", "web_share_play_store", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19569, 60),
      ))
    }

@delegate:ResourceContentHash(-2_008_753_528)
internal val Res.string.web_share_result_from: StringResource by lazy {
      StringResource("string:web_share_result_from", "web_share_result_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19630, 69),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("settings_section_play", Res.string.settings_section_play)
  map.put("settings_section_you", Res.string.settings_section_you)
  map.put("settings_share_app", Res.string.settings_share_app)
  map.put("settings_share_app_summary", Res.string.settings_share_app_summary)
  map.put("settings_starters", Res.string.settings_starters)
  map.put("settings_starters_few", Res.string.settings_starters_few)
  map.put("settings_starters_many", Res.string.settings_starters_many)
  map.put("settings_starters_none", Res.string.settings_starters_none)
  map.put("settings_starters_summary", Res.string.settings_starters_summary)
  map.put("settings_theme_mode", Res.string.settings_theme_mode)
  map.put("settings_theme_mode_dark", Res.string.settings_theme_mode_dark)
  map.put("settings_theme_mode_light", Res.string.settings_theme_mode_light)
  map.put("settings_theme_mode_system", Res.string.settings_theme_mode_system)
  map.put("settings_theme_palette", Res.string.settings_theme_palette)
  map.put("settings_title", Res.string.settings_title)
  map.put("settings_varies_by_level", Res.string.settings_varies_by_level)
  map.put("share_badge_text", Res.string.share_badge_text)
  map.put("share_streak_text", Res.string.share_streak_text)
  map.put("streak_at_risk", Res.string.streak_at_risk)
  map.put("streak_best", Res.string.streak_best)
  map.put("streak_broken", Res.string.streak_broken)
  map.put("streak_day_fri", Res.string.streak_day_fri)
  map.put("streak_day_mon", Res.string.streak_day_mon)
  map.put("streak_day_sat", Res.string.streak_day_sat)
  map.put("streak_day_sun", Res.string.streak_day_sun)
  map.put("streak_day_thu", Res.string.streak_day_thu)
  map.put("streak_day_tue", Res.string.streak_day_tue)
  map.put("streak_day_wed", Res.string.streak_day_wed)
  map.put("streak_frozen_hint", Res.string.streak_frozen_hint)
  map.put("streak_played_today", Res.string.streak_played_today)
  map.put("streak_restore_cta", Res.string.streak_restore_cta)
  map.put("streak_share", Res.string.streak_share)
  map.put("streak_start", Res.string.streak_start)
  map.put("streak_title", Res.string.streak_title)
  map.put("streak_title_zero", Res.string.streak_title_zero)
  map.put("tier_easy", Res.string.tier_easy)
  map.put("tier_expert", Res.string.tier_expert)
  map.put("tier_hard", Res.string.tier_hard)
  map.put("tier_medium", Res.string.tier_medium)
  map.put("web_share_challenge_from", Res.string.web_share_challenge_from)
  map.put("web_share_invite_from", Res.string.web_share_invite_from)
  map.put("web_share_ios_hint", Res.string.web_share_ios_hint)
  map.put("web_share_play_store", Res.string.web_share_play_store)
  map.put("web_share_result_from", Res.string.web_share_result_from)
}
